import { getBrandData } from '../app/bootstrap';
import {
    STARBUCKSJAPAN, STOREFRONT_V2, STOREFRONT_V2_FIXED, STOREFRONT_V2_PDP
} from '../constants/constants';
import { getPdpPath, SYNC_FLOW_PATHS } from '../routing/paths';

export const getHostname = () => {
    if (window && window.location && window.location.hostname) return window.location.hostname;
    return '';
};

export const getReferrer = () => {
    if (document && document.referrer) return document.referrer;
    return '';
};

export const getPath = () => {
    if (window && window.location && window.location.pathname) return window.location.pathname;
    return '';
};

// Return the pathName of the URL if user typed pathName is valid pathName else return `PAGE_NOT_FOUND`
export const pagePath = () => {
    const landedPath = getPath().toLowerCase().replace(/\/+$/, '');

    // Check if landedPath exists in SYNC_FLOW_PATHS
    const foundSyncPath = SYNC_FLOW_PATHS.find(syncPath => syncPath === landedPath);

    if (foundSyncPath === '') {
        return ('/');
    }
    if (foundSyncPath) {
        return foundSyncPath; // Return found path from SYNC_FLOW_PATH
    }
    return 'PAGE_NOT_FOUND'; 
};


export const getBuyFlow = () => {
    const { brandCode } = getBrandData();

    if (brandCode === STARBUCKSJAPAN) {
        return STOREFRONT_V2;
    }
    if (pagePath() === getPdpPath()) {
        return STOREFRONT_V2_PDP;
    }
    return STOREFRONT_V2_FIXED;
};

export const getUrlParams = () => {
    
    
    let urlParams;
    if (window && window.location && typeof URLSearchParams !== 'undefined') {
        urlParams = new URLSearchParams(window.location.search);
    }

    const sessionDetails = {
        ref: '',
        affiliateCode: ''
    };

    if (typeof urlParams !== 'undefined') {
        sessionDetails.ref = urlParams.get('ref') || '';
        sessionDetails.affiliateCode = urlParams.get('affiliate_id') || '';
    }

    return sessionDetails;
};
